import React from 'react'
import { FiClock, FiInfo } from 'react-icons/fi'
import LogoClicksign from '@resources/imgs/logo-empresa.png'
import './ContractStatus.css'

const NoContractStatus: React.FC = () => {
  return (
    <div className="contract-status-container-no-contract">
      {/* Header Section */}
      <div className="contract-header-section">
        <div className="d-flex align-items-center gap-3">
          <div className="clicksign-logo-header">
            <img src={LogoClicksign} alt="Clicksign" />
          </div>
        </div>
        <div className="status-badge-waiting">
          <FiClock size={16} />
          Aguardando envio
        </div>
      </div>

      {/* Content Section */}
      <div className="contract-content-section">
        {/* Info Message */}
        <div className="contract-waiting-message">
          <div className="waiting-icon-box">
            <FiClock size={28} />
          </div>
          <div>
            <h5 className="waiting-title mb-2">Aguardando envio do contrato</h5>
            <p className="waiting-description mb-0">
              O contrato de fornecimento de sêmen será enviado em breve.
            </p>
          </div>
        </div>

        {/* Info Alert */}
        <div className="contract-info-alert">
          <div className="info-icon-box">
            <FiInfo size={24} />
          </div>
          <div className="flex-grow-1">
            <h6 className="info-alert-title mb-2">O que esperar:</h6>
            <ul className="info-alert-list mb-0">
              <li>O contrato será enviado através da plataforma Clicksign</li>
              <li>Você receberá um e-mail com o link para visualização e assinatura digital</li>
              <li>Lembre-se de verificar sua caixa de spam</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NoContractStatus
